import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {ASML} from "../../util/RouteConstants";
import AsmlDeviceOverviewContextProvider from "./context/AsmlDeviceOverviewContext";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class AsmlDevicePage extends Component {
    render() {

        const getAsmlRoutes = () => {
            return ASML;
        }

        return (
            <Column>
                <AsmlDeviceOverviewContextProvider>
                    <TabLayout routes={getAsmlRoutes()} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={getAsmlRoutes()}/>
                </AsmlDeviceOverviewContextProvider>
            </Column>
        )
    }
}

export default AsmlDevicePage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/AsmlDevicePage.js